import React, {useEffect, useState} from "react";
import {
  AgentType,
  Board,
  BoardHeader,
  BoardSearchResult,
  CalendarBox,
  CalendarIcon,
  CancelButton, ColSpan1,
  ColSpan2,
  ColSpan3,
  ColSpan4, ColTitle,
  CustomDatePicker,
  DateContainer,
  Input,
  RelativeDiv,
  RowSpan,
  smallStyle,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../../assets/GlobalStyles";
import Checkbox from "../../../components/common/Checkbox";
import {
  AdverInfo,
  CategoryItem,
  RowInBox,
  SelectCategory
} from "../styles/common";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import {InventoryButton} from "../../../components/modal/InventorySettings";
import {Controller, useFormContext} from "react-hook-form";
import {useAtom} from "jotai";
import {stepCampaignAtom} from "../entity";
import {campaignBasicInfoAtom} from "../entity/Info";
import {
  selGroupInfo,
  selMediaCategoryInfo,
  updateCampaignConfigInventory
} from "../../../services/campaign/GroupAxios";
import {
  campaignGroupInfoAtom,
  mediaCategoryAtom,
  noViewType
} from "../entity/Group";
import {dateFormat, toDay, unlimitedDate} from "../../../common/StringUtils";
import {selEnumInfo} from "../../../services/campaign/InfoAxios";
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import {useResetAtom} from "jotai/utils";
import {campaignCreativeAtom} from "../entity/Creative";
import queryString from "query-string";

export function CampaignThree() {
  const [, setStepCampaign] = useAtom(stepCampaignAtom);
  const [campaignBasicInfo, setCampaignBasicInfo] = useAtom(campaignBasicInfoAtom);
  const [campaignGroupInfo, setCampaignGroupInfo] = useAtom(campaignGroupInfoAtom);
  const [exposureDayChecked, setExposureDayChecked] = useState(false);
  const [mediaCategory, setMediaCategory] = useAtom(mediaCategoryAtom);
  const [agentTypeState, setAgentTypeState] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [startDate, endDate] = dateRange;
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    control,
    formState: {errors},
    clearErrors
  } = useFormContext();
  const location = useLocation();
  const navigate = useNavigate();
  const resetCreativeInfo = useResetAtom(campaignCreativeAtom);
  const state = location.search !== '' ? queryString.parse(location.search) : location.state;

  useEffect(() => {
    selMediaCategoryInfo().then(response => {
      if (response) {
        setMediaCategory(response)
      }
    });

    selEnumInfo('AGENT_TYPE').then(response => {
      setAgentTypeState(response.values)
    });
  }, [])

  useEffect(() => {
    if ((state !== null || ['STEP3_INVENTORY', 'STEP4_CREATIVE', 'COMPLETED'].includes(campaignBasicInfo.step))) {
      let campaignId = state !== null ? state.campaignId : campaignBasicInfo.campaignId;

      if(campaignId !== '') {
        setCampaignGroupInfo({
          ...campaignGroupInfo,
          campaignId: campaignId
        })
      }
      selGroupInfo(campaignId).then(response => {
        if (response != null) {
          setCampaignGroupInfo(response)
          reset({name: response?.name})

          if (response.endDate === '3000-12-31') {
            setExposureDayChecked(true);
          }

          setDateRange([
            new Date(response.startDate),
            new Date(
                response.endDate !== '3000-12-31' ? response.endDate : null)
          ])
        }
      });
    } else {
      let time = dateFormat(toDay(), 'YYMMDDHHmm');
      let name = campaignBasicInfo.productType !== 'BANNER' ? 'GR_PU_' + time
          : 'GR_BA_' + time
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        name: name
      })
      setValue('name', name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state])

  useEffect(() => {
    if (dateRange?.length !== 0) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        startDate: dateFormat(startDate, 'YYYY-MM-DD'),
        endDate: dateFormat(endDate, 'YYYY-MM-DD'),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange])

  const selectedCategory = (selectedCategory) => {
    let boolCategory = campaignGroupInfo.allowInventoryCategories.includes(
        selectedCategory)
    if (!boolCategory) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        allowInventoryCategories: campaignGroupInfo.allowInventoryCategories.concat(
            selectedCategory)
      })
    } else {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        allowInventoryCategories: campaignGroupInfo.allowInventoryCategories.filter(
            value => value !== selectedCategory)
      })
    }
    clearErrors('inventoryCATEGORY')
  }
  const selectedDisExposureCategory = (selectedCategory) => {
    let boolCategory = campaignGroupInfo.disAllowInventoryCategories.includes(
        selectedCategory)
    if (!boolCategory) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        disAllowInventoryCategories: campaignGroupInfo.disAllowInventoryCategories.concat(
            selectedCategory)
      })
    } else {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        disAllowInventoryCategories: campaignGroupInfo.disAllowInventoryCategories.filter(
            value => value !== selectedCategory)
      })
    }
    clearErrors('disInventoryCATEGORY')
  }

  const setExposureInventoryType = (exposureInventoryType) => {
    setCampaignGroupInfo({
      ...campaignGroupInfo,
      exposureInventoryType: exposureInventoryType,
      allowInventoryCategories: [],
      allowInventoryIds: []
    })
    clearErrors('inventoryCATEGORY')
    clearErrors('inventoryMANUAL')
  }

  const handleRangeDate = (date) => {
    if (date?.length !== undefined) {
      setDateRange(date)
    } else {
      setDateRange([date, null])
    }

    clearErrors('endDate')
  }

  const handleCheckExposureDay = (event) => {
    setExposureDayChecked(event.target.checked)
    if (event.target.checked && startDate !== null) {
      setCampaignGroupInfo({
        ...campaignGroupInfo,
        endDate: '3000-12-31'
      })
      setDateRange([startDate, null])
    } else {
      setDateRange([null, null])
    }
  }

  const onCancel = () => {
    if (state !== null) {
      navigate(-1)
    } else {
      setStepCampaign({steps: 1})
    }
  }

  const onSubmit = () => {
    let time = dateFormat(toDay(), 'YYMMDDHHmm');
    let name = campaignBasicInfo.productType !== 'BANNER' ? 'GR_PU_' + time : 'GR_BA_' + time;
    let param = {
      ...campaignGroupInfo,
      endDate: exposureDayChecked ? unlimitedDate('YYYY-MM-DD') : endDate,
      campaignId: state !== null ? state.campaignId : campaignBasicInfo.campaignId,
      name: name
    };

    if (param.endDate === undefined) {
      setError('endDate', {type: 'required', message: '개제 기간을 선택 해주세요.'})
    } else {
      updateCampaignConfigInventory(param).then(response => {
        if (response) {
          if (state !== null) {
            toast.success("수정되었습니다.", {
              autoClose: 100,
              delay: 0,
              toastId: 'updateCampaignConfigInventory'
            })
            toast.onChange(payload => {
              if (payload.status === "removed" && payload.type
                  !== toast.TYPE.ERROR && payload.id
                  === 'updateCampaignConfigInventory') {
                navigate('/board/dashboard')
              }
            })
          } else {
            if (!['STEP3_INVENTORY', 'STEP4_CREATIVE', 'COMPLETED'].includes(
                campaignBasicInfo.step)) {
              setCampaignBasicInfo({
                ...campaignBasicInfo,
                step: "STEP3_INVENTORY"
              })
            }

            setStepCampaign({steps: 3})
          }
        }
      })
      resetCreativeInfo()
    }
  }

  const onError = (error) => console.log(error)

  return (
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        {state !== null && <AdverInfo><span>광고주 정보</span><p></p>
          <span>{state?.adverInfo}</span></AdverInfo>}
        <Board>
          <BoardHeader>광고 그룹 설정</BoardHeader>
          <BoardSearchResult>
            <RowSpan>
              <ColSpan4>
                <Span4>광고 게재 설정</Span4>
              </ColSpan4>
            </RowSpan>
            <RowSpan box={true} column={true}>
              <ColSpan4>
                <ColTitle><span>게재 지면</span></ColTitle>
                <RelativeDiv>
                  <ColSpan2>
                    <label>
                      <Controller name={'inventoryNONE'}
                                  control={control}
                                  render={({field}) =>
                                      <input
                                          type={'radio'}
                                          {...field}
                                          name={'inventory'}
                                          id={'inventoryMANUAL'}
                                          onChange={() => setExposureInventoryType(
                                              'NONE')}
                                          checked={campaignGroupInfo?.exposureInventoryType
                                              === 'NONE'}
                                      />
                                  }
                      />
                      <span>미선택</span>
                    </label>
                    <label>
                      <Controller name={'inventoryMANUAL'}
                                  control={control}
                                  rules={{
                                    required: {
                                      value: campaignGroupInfo?.exposureInventoryType
                                          === "MANUAL"
                                          && campaignGroupInfo.allowInventoryIds?.length
                                          === 0, message: '지면을 선택해주세요.'
                                    }
                                  }}
                                  render={({field}) =>
                                      <input
                                          type={'radio'}
                                          {...field}
                                          name={'inventory'}
                                          id={'inventoryMANUAL'}
                                          onChange={() => setExposureInventoryType(
                                              'MANUAL')}
                                          checked={campaignGroupInfo?.exposureInventoryType
                                              === 'MANUAL'}
                                      />
                                  }
                      />
                      <span>직접 선택</span>
                    </label>
                    {campaignGroupInfo?.exposureInventoryType === 'MANUAL' &&
                        <InventoryButton title={'게재 지면 설정'} buttonText={'지면선택'}
                                         type={'allow'}/>
                    }
                    {campaignGroupInfo?.exposureInventoryType === 'MANUAL'
                        && campaignGroupInfo.allowInventoryIds?.length !== 0 &&
                        <small>{campaignGroupInfo.allowInventoryIds?.length}개 지면
                          송출 설정</small>
                    }
                    {errors.inventoryMANUAL
                        && campaignGroupInfo.allowInventoryIds?.length === 0 &&
                        <small><ValidationScript
                            style={{position: 'unset'}}>{errors.inventoryMANUAL.message}</ValidationScript></small>}
                  </ColSpan2>
                </RelativeDiv>
              </ColSpan4>
              {campaignGroupInfo?.exposureInventoryType === 'CATEGORY' &&
                  <ColSpan4>
                    <Span4></Span4>
                    <RelativeDiv>
                      <SelectCategory>
                        {mediaCategory?.data.map((item, key) => {
                          return (
                              <CategoryItem
                                  active={campaignGroupInfo !== null
                                      && campaignGroupInfo.allowInventoryCategories.includes(
                                          item.value)}
                                  key={key} onClick={() => selectedCategory(
                                  item.value)}>{item.label}</CategoryItem>
                          )
                        })}
                      </SelectCategory>
                      {errors.inventoryCATEGORY &&
                          <small><ValidationScript>{errors.inventoryCATEGORY.message}</ValidationScript></small>}
                    </RelativeDiv>
                  </ColSpan4>
              }
              {campaignGroupInfo?.disExposureInventoryType === 'CATEGORY' &&
                  <ColSpan4>
                    <Span4></Span4>
                    <RelativeDiv>
                      <SelectCategory>
                        {mediaCategory.data.map((item, key) => {
                          return (
                              <CategoryItem
                                  active={campaignGroupInfo !== null
                                      && campaignGroupInfo.disAllowInventoryCategories.includes(
                                          item.value)}
                                  key={key}
                                  onClick={() => selectedDisExposureCategory(
                                      item.value)}>{item.label}</CategoryItem>
                          )
                        })}
                      </SelectCategory>
                      {errors.disInventoryCATEGORY &&
                          <ValidationScript>{errors.disInventoryCATEGORY.message}</ValidationScript>}
                    </RelativeDiv>
                  </ColSpan4>
              }
              <RowSpan validation  style={{justifyContent: 'flex-start'}}>
                <ColSpan1>
                  <ColTitle><span>게재 기간</span></ColTitle>
                    <DateContainer>
                      <CalendarBox>
                        <CalendarIcon/>
                      </CalendarBox>
                      <Controller
                          control={control}
                          name="endDate"
                          rules={{
                            required: {
                              value: (exposureDayChecked ? dateRange[0] === null
                                  : dateRange[1] === null),
                              message: '게재 기간을 설정해주세요'
                            }
                          }}
                          render={({field: {onChange, onBlur, value, ref}}) => (
                              <CustomDatePicker
                                  selectsRange={!exposureDayChecked}
                                  startDate={startDate}
                                  endDate={endDate}
                                  placeholderText={'날짜를 입력해 주세요.'}
                                  minDate={new Date()}
                                  onChange={(date) => handleRangeDate(date)}
                                  dateFormat="yyyy-MM-dd"
                                  locale={ko}
                                  isClearable={false}
                                  onBlur={onBlur}
                                  selected={startDate}
                                  inputRef={ref}
                                  monthsShown={2}
                                  openToDate={startDate}
                              />
                          )}
                      />
                      {errors.endDate &&
                          <ValidationScript>{errors.endDate.message}</ValidationScript>}
                    </DateContainer>
                </ColSpan1>
                  <ColSpan1>
                    <label>
                      <input type={'checkbox'}
                             className={'checkbox-type-a'}
                             checked={exposureDayChecked}
                             onChange={handleCheckExposureDay}
                      />
                      <i/>
                      <span>종료일 미설정</span>
                    </label>
                  </ColSpan1>
              </RowSpan>
            </RowSpan>
          </BoardSearchResult>
        </Board>
        <SubmitContainer>
          <CancelButton type={'button'} onClick={() => onCancel()}>{state
          !== null ? '목록' : '이전'}</CancelButton>
          <SubmitButton type={'submit'}>{state !== null ? '수정'
              : '다음[3/4]'}</SubmitButton>
        </SubmitContainer>

      </form>
  )
}